import BaseService from "./base.service";
const service = new BaseService("/divalto_agencies")
export default service;
